import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import {
  ApprovalPolicy,
  ApprovalPolicyPreview,
  ApprovalPolicyPreviewCommand,
  ApprovalPolicySearchCommand,
  ApprovalPolicyUpdate,
  PagedResult,
} from '../models/approval-policy/approval-policy';

@Injectable({ providedIn: 'root' })
export class ApprovalPolicyProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/approval-policy`;

  getById(id: string): Observable<ApiResponse<ApprovalPolicy>> {
    return this.httpClient.get<ApiResponse<ApprovalPolicy>>(`${this.baseUrl}/${id}`);
  }

  search(
    command: ApprovalPolicySearchCommand,
    pageNumber: number,
    pageSize: number,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PagedResult<ApprovalPolicy>>> {
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder);
    return this.httpClient.post<ApiResponse<PagedResult<ApprovalPolicy>>>(`${this.baseUrl}/search`, command, { params });
  }

  create(policy: ApprovalPolicyUpdate): Observable<ApiResponse<ApprovalPolicy>> {
    return this.httpClient.post<ApiResponse<ApprovalPolicy>>(this.baseUrl, policy);
  }

  update(id: string, policy: ApprovalPolicyUpdate): Observable<ApiResponse<ApprovalPolicy>> {
    return this.httpClient.put<ApiResponse<ApprovalPolicy>>(`${this.baseUrl}/${id}`, policy);
  }

  /** Dry run: what saving would say, explained per amount band, plus an optional simulation. Writes nothing. */
  preview(command: ApprovalPolicyPreviewCommand): Observable<ApiResponse<ApprovalPolicyPreview>> {
    return this.httpClient.post<ApiResponse<ApprovalPolicyPreview>>(`${this.baseUrl}/preview`, command);
  }
}
